'use strict';

/**
 * Representación legible de una cohorte: transforma los datos en crudo en una lista de definición legible
 *
 * Por ejemplo, para la entrada {site: 1, 10: 2} daría algo parecido a:
 * <dl>
 *     <dt>Centro</dt>
 *     <dd>01</dd>
 *     <dt>Sexo</dt>
 *     <dd>Varón</dd>
 * </dl>
 */
angular.module('randomization')
    .component('randomizationCohort', {
        templateUrl: 'modules/randomization/components/cohort/content.html',
        controller: 'RandomizationCohortController',
        bindings: {
            data: '<', // Los datos de la cohorte a representar
        },
    });
